module.exports = __webpack_public_path__ + "img/pdf.bc39240a.svg";